import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, downloadFile, leftPad, closeCollapsible } from '../../../utils/util';
import { Breadcrumbs, Button, InfiniteScroll, Input, Collapsible } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';

const GeneralReport = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const [reportItems, setReportItems] = useState();
    const [filter, setFilter] = useState(
        {
            mvmNumber: "",
            journey: "",
            inicialDate: "",
            finalDate: "",
            mdrType: "",
            status: "",
            partnumber: "",
            success: true
        });

    useEffect(() => {
        if (reportItems?.items.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(reportItems?.items);
            } else {
                setData((prevState) => ([...prevState, ...reportItems?.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [reportItems?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        return () => {
            setData([]);
            setReportItems();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport")) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
                setData([]);
            }
            props.getListGeneralReport(filter, {
                PageSize: 25,
                PageIndex: currentPageList
            }, (data) => {
                setReportItems(data);
                if (click) {
                    closeCollapsible("collapsible2")
                }
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const downloadReport = () => {
        props.getGeneralReport(filter, (data) => {
            downloadFile(data, `ChangeReport${Date.now()}.csv`, "data:text/csv", true);
        });
    }

    const renderItem = (item, index) => {
        return (
            <div
                style={{ display: 'block', padding: '10px', height: 'auto' }}
                key={`oi-${index}`}
            >
                <div className="row" style={{ marginBottom: '0px' }}>
                    {
                        item?.receipt.mvmNumber &&
                        <div className="col s12" style={{ color: 'black' }}>
                            MVM {item?.receipt.mvmNumber}
                        </div>
                    }
                    {
                        item?.receipt.journey &&
                        <div className="col s12" style={{ color: 'black' }}>
                            {translate('physical-confirmation:journey')} {item.receipt.journey}
                        </div>
                    }
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:supplier')}: ${(item.receipt.supplier) ? item.receipt.supplier : 'N/A'}`}</label>
                    </div>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:mdr-origin')}: ${item.receipt.mdr}`}</label>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:mdr')}: ${item.mdr}`}</label>
                    </div>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:qme-origin')}: ${item.receipt.qme}`}</label>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:qme')}: ${item.boxQuantityItems}`}</label>
                    </div>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:part-number')}: ${item.receipt?.partNumberCode}`}</label>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s12">
                        <label>{item.createdByDesc}</label>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Breadcrumbs id="reportTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: translate('physical-confirmation:qme-mdr-changes') }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.inicialDate}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="inicialDate"
                                            name="inicialDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.finalDate}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="finalDate"
                                            name="finalDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="mvm"
                                            name='mvm'
                                            label={translate('physical-confirmation:mvm')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="supplier"
                                            name='supplier'
                                            label={translate('physical-confirmation:supplier')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            type="text"
                                            label={translate('physical-confirmation:mdr')}
                                            id="mdrType"
                                            name="mdrType"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            type="text"
                                            label={translate('physical-confirmation:part-number')}
                                            id="partnumber"
                                            name="partnumber"
                                            onChange={onChange}
                                            numericonly="true"
                                            value={filter.partnumber}
                                            maxLength={11}
                                            onBlur={(ev) => {
                                                const formatted = leftPad(ev.target.value, 11, '0');
                                                if (ev.target.value.length === 0 || formatted === ev.target.value) {
                                                    return;
                                                }

                                                ev.target.value = formatted;
                                                onChange(ev);
                                            }}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            type="text"
                                            label={translate('physical-confirmation:user')}
                                            id="createdByDesc"
                                            name="createdByDesc"
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button
                                        onClick={() => onFilter(true)}
                                        full="true"
                                        text={translate('delivery:general.search')} />
                                </div>
                            </>
                        }
                    />
                    {
                        data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text={translate('general.generateReport')} />
                        </div>
                    }
                </div>
                <div id="list" style={{ marginLeft: '5px' }}>
                    <InfiniteScroll
                        page={reportItems?.totalPages}
                        hasMore={currentPage < reportItems?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item, index) => {
                                return renderItem(item, index);
                            })
                        }
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListGeneralReport: (filter, pagination, callback) => {
            dispatch(PhysicalConfirmationService.getListChangeReport(filter, pagination, callback));
        },
        getGeneralReport: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getChangeReport(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GeneralReport)));
